import React, { useState } from 'react';
import axios from 'axios';
import Modal from './UI/Modal/Modal';
import { useSelector, useDispatch } from 'react-redux';
import Products from './Products';
import { define, tokenExpiredMsg, expNotifyDuration } from '../data/globals'
import { useNotify } from '../hooks/useNotify';


const Categories = (props) => {
    // Redux
    const updCatId = useSelector(state => state.updCat.id)
    const dispath = useDispatch()
    const [idToDelete, setIdToDelete] = useState(0)
    const [modalCatName, setModalCatName] = useState('')
    const [delModal, setDelModal] = useState(false)
    const { pushNotify } = useNotify()

    function selectCategory(id, name, description) {
        // Если клик на категории выполнен повторно - устанавливаем action='updC' и прерываем выполнение (не запускаем getProducts)
        if(id === updCatId) {
            dispath({ type: 'SetActionUpdCAgain' })
            return
        }

        dispath({
            type: 'SetUpdCategory',
            id: id,
            name: name,
            description: description
        })

        props.getProducts(id)
    }

    function confirmDelete(id, name) {
        setIdToDelete(id)
        setModalCatName('Вы действительно хотите удалить<br>категорию <b>' + name + '</b>?')
        setDelModal(true)
    }

    // Скрываем модальное окно
    function hideModal() {
        setDelModal(false)
    }

    // ########################################################
    // Добавить удаление изображений связаных с товаром
    // Здесь на фронте или на бэке. Скорее всего лучше на бэке
    // ########################################################

    // Удаление подтверждено. Удаляем категорию и все товары из нее
    async function deleteCategory() {

        try {
            const response = await axios({
                method: 'post',
                url: define.pathToAPI + '/categories/delete.php',
                data: JSON.stringify({
                    id: idToDelete,
                    userToken: localStorage.getItem('AuthToken'),
                }),
                // headers: {
                //     "Content-type": "application/json; charset=UTF-8"
                // }
            })// axios

            // проверка ответа от delete.php
            switch(response.data.message){
                case 'Категория удалена':
                    props.deleteCatsData( idToDelete )
                    setDelModal( false )
                    break
                case 'Токен устарел!':
                    pushNotify(tokenExpiredMsg, "notifyWelcome", expNotifyDuration)
                    // props.pushNotify(tokenExpiredMsg, "notifyWelcome", expNotifyDuration)
                    // ########################################################
                    // При блокировке доступа, удалить картинки, которые не были сохранены в базе
                    // ########################################################
                    break
                case 'Токены не совпадают! Доступ запрещен':
                    // dispath({ type: 'SetAuthStatus', authStatus: 'denied' })
                    pushNotify("Токены не совпадают! Alarm! Доступ запрещен", "notifyWelcome")
                    // props.pushNotify("Токены не совпадают! Alarm! Доступ запрещен", "notifyWelcome")
                    // ########################################################
                    // При блокировке доступа, удалить картинки, которые не были сохранены в базе
                    // ########################################################
                    break
                default:
                    console.log('Ошибка при удалении категории.\nСервер отвечает (код 200). Но нет подтверждения от delete.php, что категория удалена')
                    alert('Ошибка при удалении категории (см.  консоль)')
                    break
            } // switch

        } catch (e) {
            if(e === 'AxiosError: Request failed with status code 400') {
                console.log('Ошибка при удалении категории\nКод: 400 - Некорректный ID\n(см. update.php)')
                alert('Ошибка (код: 400) при удалении категории (см.  консоль)')
            } else {
                console.log('Ошибка при удалении категории\n' + e)
                alert('Ошибка при удалении категории\n' + e)
            }
        }// try
    }

    return (
        <>
            <Modal
                visible={delModal}
                modalColors="modalOrange"
                header="Удаление"
                pic='alert'
                message={modalCatName}
                btn1Text="Да"
                btn2Text="Нет"
                сonfirmed={deleteCategory}
                hide={hideModal}
            />
            {props.categories.map((cat) =>
                <div key={cat.id}>
                    <div
                        className={`catItem ${cat.id === updCatId ? "current" : ''}`}
                        onClick={() => selectCategory(cat.id, cat.name, cat.description)}
                    >
                        <img src={ define.pathToGraphics + '/folder_18px.png' } className='ml-4 mr-6' alt=''/>
                        <div className="grow1">
                            { cat.name }
                            {/* [{ cat.id }] */}
                            {/* { cat.name } / { cat.description } [{ cat.id }] */}
                        </div>
                        <div
                            className='catBtn'
                            onClick={(e)=>props.selectAddProd(e, cat.id, cat.name)}
                            ><img src={ define.pathToGraphics + '/add2_18px.png' } alt=''/></div>
                        <div
                            className='catBtn'
                            onClick={(e) => {
                                e.stopPropagation();
                                confirmDelete(cat.id, cat.name)} }
                            ><img src={ define.pathToGraphics + '/delete_16px.png' } alt=''/></div>
                    </div>
                    <div>
                    {(cat.id === updCatId) && 
                        (!props.isProdsLoading ?
                        <Products
                            products={ props.products }
                            deleteProdsData={ props.deleteProdsData }
                            // pushNotify={ props.pushNotify }
                        />
                        : <div className='ml-30'>Идет загрузка...</div> )
                    }
                    </div>
                </div>
            )}
        </>
    )
}

export default Categories
// export default memo(Categories)